import { render, staticRenderFns } from "./card-kynorelle.vue?vue&type=template&id=5aaa9ef1&scoped=true&"
import script from "./card-kynorelle.vue?vue&type=script&lang=js&"
export * from "./card-kynorelle.vue?vue&type=script&lang=js&"
import style0 from "./card-kynorelle.vue?vue&type=style&index=0&id=5aaa9ef1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaa9ef1",
  null
  
)

export default component.exports